
import React from 'react';
import About from '../components/About'; // Adjust path if Navbar is in a different folder
import WhoAreWe from '../components/WhoAreWe'; 
import Footer from '../components/Footer'; 
import Cards from '../components/Cards'; 
const AboutUs = () => {
  return (
    <div className="pt-10 md:pt-6">
      
      <WhoAreWe />
      <h2 className="px-6 text-lg md:text-3xl font-bold text-start md:text-center text-slate-800 mb-1 md:mb-3">
          SIAMO QUI PER SUPPORTARTI
        </h2>
         <div className="w-40 md:w-80 h-1 mx-6 md:mx-auto mb-6 md:mb-12 rounded-full bg-gradient-to-r from-[#F2C231] to-[#C69A32]" />
         <div className="pb-16 md:pb-28" />
          
      <Cards />
      <div className="pb-16 md:pb-28" />
    </div>
  );
};

export default AboutUs;

